import useAxios from 'axios-hooks';

export interface IReviewSummaryReport extends ICommitteeApprovalDate {
  cgrScoreStatus: boolean;
  draftReportStatus: boolean;
  completedAllSection: boolean;
  publishedDate: Date | null;
}

export interface ICommitteeApprovalDate {
  committeeApprovalDate: Date | null;
}

export interface IDraftReport {
  isDraftReport: boolean;
}

export const useGetReviewSummaryReport = (
  reportId?: string,
  companyId?: string
) => {
  return useAxios<IReviewSummaryReport>({
    url: `/reports/${reportId}/summarize?companyId=${companyId}`,
    method: 'GET',
  });
};

export const useSaveDraftReportStatus = (
  reportId?: string,
  payload?: IDraftReport
) => {
  return useAxios<IDraftReport>(
    {
      url: `/reports/${reportId}/draft`,
      data: payload,
      method: 'POST',
    },
    { manual: true }
  );
};

export const useSaveCommitteeApprovalDate = (
  reportId?: string,
  payload?: ICommitteeApprovalDate
) => {
  return useAxios<ICommitteeApprovalDate>(
    {
      url: `/reports/${reportId}/committee-approval`,
      data: payload,
      method: 'POST',
    },
    { manual: true }
  );
};

export const usePublishReport = (reportId?: string) => {
  return useAxios<IReviewSummaryReport>(
    {
      url: `/reports/${reportId}/publish`,
      method: 'POST',
    },
    { manual: true }
  );
};
